module.exports = __webpack_public_path__ + "img/share-word.0df5dae.svg";